import React, { useState, useEffect,useRef,useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import AssetModalWrapper from './AssetModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker, Tabs, Card, Timeline, Popconfirm, InputNumber, Checkbox, TimePicker, Upload, Space, Switch, Radio } from 'antd';
import { CloseOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import modalActions from '@iso/redux/modal/actions';
import Loader from '@iso/components/utility/loader';
import { assetService } from '@iso/services';
import moment from 'moment';
import _ from 'lodash';
import styled from "styled-components";
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import L from 'leaflet';
import inside from 'point-in-polygon';
import { assetCategories } from '@iso/constants/assetCategories';
import { inventoryTypes } from '@iso/constants/inventoryTypes';
import { educationTypes } from '@iso/constants/educationTypes';
import { assetStates } from '@iso/constants/assetStates';
import { containerUnits, getContainerUnitSuffix } from '@iso/constants/containerUnits';
import { treatmentRates } from '@iso/constants/treatmentRates';
import {
  getHealthSafetyTypeOptionsByCategory,
  normalizeHealthSafetyType,
  requiresCreationDate,
  requiresLastCheckedDate,
  requiresLocation,
  requiresManufactureDate,
  requiresTags,
} from '@iso/constants/healthSafetyTypes';
import { fuelTypes } from '@iso/constants/fuelTypes';
import { fuelContainerUnits, getFuelContainerUnitSuffix } from '@iso/constants/fuelContainerUnits';
import { storageTypes, tankStorageTypes } from '@iso/constants/storageTypes';
import { feedUnits } from '@iso/constants/feedUnits';
import { waterStorageTypes } from '@iso/constants/waterStorageTypes';
import { aircraftTypes } from '@iso/constants/aircraftTypes';
import { aircraftUnits } from '@iso/constants/aircraftUnits';
import { animalTypes } from '@iso/constants/animalTypes';
import { objectColors } from '@iso/constants/objectColors';
import { weatherTypes } from '@iso/constants/weatherTypes';
import { levelTypes } from '@iso/constants/levelTypes';
import { waterTypes } from '@iso/constants/waterTypes';
import { weatherDuration } from '@iso/constants/weatherDuration';
import { propertyService,healthsafety,attachment,userService } from '@iso/services';
import { Map, TileLayer, FeatureGroup, Polygon, Tooltip, ZoomControl,Marker,Popup } from 'react-leaflet';
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import TagsInput from 'react-tagsinput'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import 'react-tagsinput/react-tagsinput.css'
import { shedTypes } from '@iso/constants/shedTypes';
import { FORMULATION_TYPES } from '@iso/constants/formulationTypes';
import { propertyHelper } from "@iso/lib/helpers/propertyHelper";
import SprayForm from './SprayForm';
import FileBrowser from '@iso/components/FileBrowser/FileBrowser';
import SelectedFilesDisplay from '@iso/components/FileBrowser/SelectedFilesDisplay';

const { Option, OptGroup } = Select;
const { closeModal } = modalActions;
const { TabPane } = Tabs;

const RATE_PER_OPTIONS = [
  { value: 'per_100l', label: 'Rate per 100L' },
  { value: 'per_hectare', label: 'Rate per hectare' },
];

const RATE_UNIT_OPTIONS = [
  { value: 'kg', label: 'Kg' },
  { value: 'l', label: 'L' },
  { value: 'ml', label: 'mL' },
  { value: 'g', label: 'g' },
];

const AssetModal = (props) => {
  const [form] = Form.useForm();
  const [fields, setFields] = useState([]);
  const dispatch = useDispatch();
  const modalVisibility = useSelector((state) => state.modal.modalVisibility);
  const modalData = useSelector((state) => state.modal.modalData);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [dataAsset, setDataAsset] = useState({});
  const [animalSire, setAnimalSire] = useState({});
  const [currentTab, setCurrentTab] = useState('1');
  const [valueLat, setValuelat] = useState();
  const [valueLng, setValueLng] = useState();
  const [property, setProperty] = useState();
  const [corporateGroupId, setCorporateGroupId] = useState(null);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const [position, setPosition] = useState([null, null]);
  const dateFormat = 'DD/MM/YYYY';
  const [attachmentId, setAttachmentId] = useState([]);
  const [attachmentActivityId, setAttachmentActivityId] = useState([]);
  const [fileBrowserVisible, setFileBrowserVisible] = useState(false);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [tags, setTags] = useState([]);
  const [users, setUsers] = useState([]);
  const [primaryTrainerIsExternal, setPrimaryTrainerIsExternal] = useState(false);
  const [secondaryTrainerHasExternal, setSecondaryTrainerHasExternal] = useState(false);
  const currentUser = useSelector((state) => state.user.user);
  const activePropertySubscription = useSelector((state) => state.subscription.activePropertySubscription);
  const [primaryObjects, setPrimaryObjects] = useState([]);

  const mapRef = useRef();
  const assetType = Form.useWatch(['asset', 'type'], form);
  const assetCategory = Form.useWatch(['asset', 'category'], form);
  const normalizedHealthSafetyType = React.useMemo(
    () => normalizeHealthSafetyType(assetType),
    [assetType]
  );

  // Derive property data from parent props instead of calling viewProperty API
  useEffect(() => {
    if (props.property) {
      setProperty(props.property);
      setCorporateGroupId(props.property.corporate_group_id || null);

      let centerLat = props.property.lat;
      let centerLng = props.property.lng;

      if (props.primaryObjects && props.primaryObjects.length > 0) {
        const firstObject = props.primaryObjects[0];
        if (firstObject.lat_centroid && firstObject.lng_centroid) {
          centerLat = firstObject.lat_centroid;
          centerLng = firstObject.lng_centroid;
        }
      }

      setPosition([centerLat, centerLng]);
    }
  }, [props.property, props.primaryObjects]);

  // Load users for trainer selection — only when modal is visible
  useEffect(() => {
    if (modalVisibility && activePropertyId) {
      userService.getUserForProperty(activePropertyId).then(res => {
        if (res && res.code === '0000') {
          setUsers(res.users || []);
        }
      }).catch(err => {
        console.error('Error loading users for trainers:', err);
      });
    }
  }, [modalVisibility, activePropertyId]);
  
  useEffect(() => {

      setFields([
        {
          name: ['asset', 'last_checked_date'],
          value: moment(),
        },   
        {
          name: ['asset', 'quantity'],
          value: 1,
        },   
        {
          name: ['asset', 'creation_date'],
          value: moment(),
        },        
        {
          name: ['asset', 'expiry_date'],
          value: moment(),
        },     
        {
          name: ['asset', 'created_by'],
          value: currentUser ? currentUser.name : '',
        },
        {
          name: ['asset', 'available_to_contractor'],
          value: false,
        },
        {
          name: ['asset', 'permits'],
          value: [],
        },
        {
          name: ['asset', 'crops'],
          value: [],
        },

      ]);

  }, [props.propertyId]);
  useEffect(() => {
    if (assetCategory === 'health_and_safety' && !requiresTags(normalizedHealthSafetyType) && tags.length) {
      setTags([]);
    }
  }, [assetCategory, normalizedHealthSafetyType, tags.length]);

  useEffect(() => {
    if (assetCategory === 'health_and_safety' && !requiresLocation(normalizedHealthSafetyType)) {
      setValuelat(undefined);
      setValueLng(undefined);
      form.setFieldsValue({
        latitude: undefined,
        longitude: undefined,
      });
    }
  }, [assetCategory, normalizedHealthSafetyType, form]);

  // Handle primary_object_id when category changes
  useEffect(() => {
    if (assetCategory === 'education') {
      // Clear primary_object_id for education assets
      form.setFieldsValue({
        asset: {
          ...form.getFieldValue('asset'),
          primary_object_id: undefined,
        }
      });
    } else if (assetCategory && props.primaryObjects && props.primaryObjects.length > 0) {
      // Set default primary_object_id to first item for non-education assets
      const currentValue = form.getFieldValue(['asset', 'primary_object_id']);
      if (!currentValue) {
        form.setFieldsValue({
          asset: {
            ...form.getFieldValue('asset'),
            primary_object_id: props.primaryObjects[0].id,
          }
        });
      }
    }
  }, [assetCategory, props.primaryObjects, form]);

  // Fetch primary objects (polygons) when modal opens
  useEffect(() => {
    if (modalVisibility && activePropertyId) {
      propertyService.viewProperty(activePropertyId).then(res => {
        if (res.code === '0000' && res.primary_objects) {
          setPrimaryObjects(res.primary_objects);
        }
      }).catch(err => {
        console.error('Error loading primary objects:', err);
      });
    }
  }, [modalVisibility, activePropertyId]);

  const handleChangeTag = (input_tags) => {
    setTags(input_tags);
  }
  const handleFileBrowserSelect = (files) => {
    setSelectedAttachments(files);
    setAttachmentId(files.map(f => f.id));
    setFileBrowserVisible(false);
  };

  const handleRemoveAttachment = (fileId) => {
    setSelectedAttachments(prev => prev.filter(f => f.id !== fileId));
    setAttachmentId(prev => {
      const ids = Array.isArray(prev) ? prev : [];
      return ids.filter(id => id !== fileId);
    });
  };

  const handleExpiryDateChange = (targetId, newDate) => {
    attachment.updateAttachment(targetId, { expiry_date: newDate ?? '' }).then(res => {
      if (res && res.code === '0000') {
        setSelectedAttachments(prev => prev.map(f => {
          if (f.id === targetId) {
            return { ...f, expiry_date: newDate };
          }
          return f;
        }));
      }
    });
  };

  const handleUserChange = (targetId, userId) => {
    attachment.updateAttachment(targetId, { user_id: userId ?? '' }).then(res => {
      if (res && res.code === '0000') {
        const updatedUser = res.attachment?.user || null;
        setSelectedAttachments(prev => prev.map(f => {
          if (f.id === targetId) {
            return { ...f, user_id: userId, user: updatedUser };
          }
          return f;
        }));
      }
    });
  };

  const handlePermitAttachmentChange = (index, info) => {
    const assetValue = form.getFieldValue('asset') || {};
    const permitsValue = (assetValue.permits || []).map((item) => ({ ...item }));
    if (!permitsValue[index]) {
      permitsValue[index] = {};
    }

    if (info.file.status === 'removed') {
      permitsValue[index].attachment_id = null;
      permitsValue[index].attachment = null;
    }

    if (info.file.status === 'done' && info.file.response && info.file.response.attachment) {
      permitsValue[index].attachment_id = info.file.response.attachment.id;
      permitsValue[index].attachment = info.file.response.attachment;
    }

    form.setFieldsValue({
      asset: {
        ...assetValue,
        permits: permitsValue,
      },
    });
  };

  const renderPermitTab = () => (
    <Form.List name={['asset', 'permits']}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button type="dashed" icon={<PlusOutlined />} onClick={() => add({})}>
            Add permit
          </Button>
          {fields.length === 0 ? (
            <span>No permits added.</span>
          ) : (
            fields.map((field, index) => (
              <Card
                key={field.key}
                size="small"
                title={`Permit ${index + 1}`}
                style={{ width: '100%' }}
                extra={
                  <Button danger size="small" onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                }
              >
                <Form.Item name={[field.name, 'id']} hidden>
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'crop_usage']}
                      label="Crop usage"
                      rules={[{ required: true, message: 'This field is required' }]}
                    >
                      <Input placeholder="e.g. Wheat" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate']}
                      label="Rate"
                    >
                      <InputNumber min={0} style={{ width: '100%' }} placeholder="Rate" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate_per']}
                      label="Rate per"
                    >
                      <Select placeholder="Select rate per" allowClear>
                        {RATE_PER_OPTIONS.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Min rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'min_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 70px)' }} placeholder="Min rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'min_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: "70px" }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Max rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'max_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 70px)' }} placeholder="Max rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'max_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: "70px" }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_harvest']}
                      label="WHP - Harvest"
                    >
                      <Input placeholder="WHP - Harvest" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_grazing']}
                      label="WHP - Grazing"
                    >
                      <Input placeholder="WHP - Grazing" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'permit_code']}
                      label="Permit ID"
                    >
                      <Input placeholder="Permit ID" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'expiry_date']}
                      label="Expiry date"
                    >
                      <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item name={[field.name, 'attachment_id']} hidden>
                  <Input />
                </Form.Item>
                <Form.Item label="Attachment">
                  <Upload
                    name="Attachment[file]"
                    action={apiEndpoint.attachments}
                    headers={authHeader(true)}
                    data={() => {
                      const permits = form.getFieldValue(['asset', 'permits']) || [];
                      const expiryDate = permits[index] && permits[index].expiry_date;
                      return expiryDate ? { expiry_date: dateHelper.dateForAPI(moment(expiryDate)) } : {};
                    }}
                    onChange={(info) => handlePermitAttachmentChange(field.name, info)}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
              </Card>
            ))
          )}
        </Space>
      )}
    </Form.List>
  );

  const renderCropTab = () => (
    <Form.List name={['asset', 'crops']}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button type="dashed" icon={<PlusOutlined />} onClick={() => add({ allow_use: true })}>
            Add crop
          </Button>
          {fields.length === 0 ? (
            <span>No crops defined.</span>
          ) : (
            fields.map((field, index) => (
              <Card
                key={field.key}
                size="small"
                title={`Crop ${index + 1}`}
                style={{ width: '100%' }}
                extra={
                  <Button danger size="small" onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                }
              >
                <Form.Item name={[field.name, 'id']} hidden>
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'crop_name']}
                      label="Crop name"
                      rules={[{ required: true, message: 'This field is required' }]}
                    >
                      <Input placeholder="Crop name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate']}
                      label="Rate"
                    >
                      <InputNumber min={0} style={{ width: '100%' }} placeholder="Rate" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name={[field.name, 'rate_per']}
                      label="Rate per"
                    >
                      <Select placeholder="Select rate per" allowClear>
                        {RATE_PER_OPTIONS.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Min rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'min_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 120px)' }} placeholder="Min rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'min_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: 90 }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Max rate">
                      <Input.Group compact>
                        <Form.Item
                          name={[field.name, 'max_rate']}
                          noStyle
                        >
                          <InputNumber min={0} style={{ width: 'calc(100% - 120px)' }} placeholder="Max rate" />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'max_rate_unit']}
                          noStyle
                        >
                          <Select placeholder="Unit" allowClear style={{ width: 90 }}>
                            {RATE_UNIT_OPTIONS.map((unit) => (
                              <Option key={unit.value} value={unit.value}>
                                {unit.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_harvest']}
                      label="WHP - Harvest"
                    >
                      <Input placeholder="WHP - Harvest" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name={[field.name, 'whp_grazing']}
                      label="WHP - Grazing"
                    >
                      <Input placeholder="WHP - Grazing" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name={[field.name, 'allow_use']}
                  label="Allow use on crop"
                  valuePropName="checked"
                >
                  <Switch checkedChildren="Allow" unCheckedChildren="Disallow" />
                </Form.Item>
              </Card>
            ))
          )}
        </Space>
      )}
    </Form.List>
  );

  useEffect(() => {
    const {current = {}} = mapRef;
    const {leafletElement: map} = current;      
    if (!map) return;
    if(props.primaryObjects)
    {
      var boudary = [];
      _.forEach(props.primaryObjects, (object, index) => {
        boudary.push([object.lat_centroid, object.lng_centroid]);
      })
    }

    if(boudary.length != 0)
    {
      map.fitBounds(boudary);
    }

  }, [mapRef])
  const onChange = (key) => {
    setCurrentTab(key);
    // The map mounts while the Location tab is hidden, so Leaflet measures zero
    // size and tiles render as grey. Invalidate after the tab animation completes.
    if (key === "2") {
      setTimeout(() => {
        const map = mapRef.current?.leafletElement;
        if (map) map.invalidateSize();
      }, 300);
    }
  };
  const handleClickMap = (e) => {
     const { lat, lng } = e.latlng;
      form.setFieldsValue({
        latitude: lat,
        longitude: lng,
      });

     setValueLng(lng);
     setValuelat(lat);
  };
  useEffect(() => {
    if(modalVisibility && modalData.type === 'asset' && props.propertyId){
       assetService.getAnimalSire(props.propertyId).then(res => {
        if(res.code === '0000'){
          setAnimalSire(res.animal_sires);
        }
      });
      // Pre-populate location from the pin the user dropped on the property map.
      const point = modalData.object && modalData.object.point;
      if (point && point.lat != null && point.lng != null) {
        form.setFieldsValue({ latitude: point.lat, longitude: point.lng });
        setValuelat(point.lat);
        setValueLng(point.lng);
        setPosition([point.lat, point.lng]);
      }
    }
  }, [props.propertyId, modalVisibility, modalData.type, modalData.object, form]);


  const hasManualCoordinates = (lat, lng) =>
    lat !== undefined &&
    lat !== null &&
    lat !== '' &&
    lng !== undefined &&
    lng !== null &&
    lng !== '';

  const getRandomLatLng = (coordinates) => {
    var polygon = L.polygon([
      coordinates
    ]);
    var bounds = polygon.getBounds();
    var x_max = bounds.getEast();
    var x_min = bounds.getWest();
    var y_max = bounds.getSouth();
    var y_min = bounds.getNorth();
    var lat=0,lng = 0;
    var count = 0;
    var area = polygon.getLatLngs()[0].map(function(point){
      return [point.lat, point.lng]            
    });

    while(!inside([lat, lng], area)){
      lat = y_min + (Math.random() * (y_max - y_min));
      lng = x_min + (Math.random() * (x_max - x_min));
      count+=1;
      if(count==100){
        break;
      }      
    }            

    return new L.LatLng(
          lat,
          lng
    );
  }
  const getLatLng = (cLat, cLng) => {
    const lat = parseFloat(cLat);
    const lng = parseFloat(cLng);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return null;
    }
    return new L.LatLng(
          lat,
          lng
    );
  }

  const cancelModal = () => {
    dispatch(closeModal());
    if (modalData.layer) {
      modalData.featureGroup.leafletElement.removeLayer(modalData.layer);
    }
    setLoading(false);
    setFileBrowserVisible(false);
    setSelectedAttachments([]);
    setValuelat(undefined);
    setValueLng(undefined);
    form.resetFields();
  }

  useEffect(() => {
    if(props.dataObject){
      setFields([
        {
          name: ['asset', 'primary_object_id'],
          value: props.dataObject.id || '',
        },
      ])
    } else if (modalVisibility && props.primaryObjects && props.primaryObjects.length > 0) {
      // Set default primary_object_id to first item when creating new asset (non-education)
      const currentCategory = form.getFieldValue(['asset', 'category']);
      if (currentCategory !== 'education') {
        form.setFieldsValue({
          asset: {
            ...form.getFieldValue('asset'),
            primary_object_id: props.primaryObjects[0].id,
          }
        });
      }
    }
  }, [modalVisibility])

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        onStore(values);
        setAttachmentId([]);
        setSelectedAttachments([]);
        setAttachmentActivityId('');
        setValueLng('');
        setValuelat('');
      })
      .catch(info => {
        console.error('Validate Failed:', info);
        setLoading(false);
      });
  }

  const getPointList = async (selectedPrimaryObject, quantity) => {
    let arrayPoints = [];
    const newPoints = [];
    await assetService.getByPrimaryObject(selectedPrimaryObject.id).then(res => {
      if(res.code === "0000"){
        _.forEach(res.facilities, (asset) => {
          if(asset.lat && asset.lng){
            arrayPoints.push(
              {
                "lat": asset.lat,
                "lng": asset.lng
              }
            );
          }  
        });
      }
    });
    const allMarkerAreas = await props.listAllMarkerArea(selectedPrimaryObject);
    if(allMarkerAreas){
      _.forEach(allMarkerAreas, function(point){
        if((!arrayPoints.length || !_.find(arrayPoints, point)) && newPoints.length < quantity){
          newPoints.push(point);
        }
      });
    }
    return newPoints
  }

  const onStore = async (values) => {
    let color = '';
    const selectedObject = _.find(props.primaryObjects, (object) => {
      return object.id === values.asset.primary_object_id;
    });

    if(values.asset.category === 'animal')
    {
      objectColors.map((value, index) => {
        if(value.value == values.asset.tag_colour){ color = value.label}
      });
    }
  
    var point = null;
    let normalizedHealthSafetyTypeValue = values.asset.type;
    if(selectedObject && values.asset.category === 'water' && values.asset.quantity > 1){
      const newPoints = await getPointList(selectedObject, values.asset.quantity)
      if(newPoints.length){
        values.asset.point_list = newPoints
      }
    }

    if(values.asset.category === 'health_and_safety'){
      normalizedHealthSafetyTypeValue = normalizeHealthSafetyType(values.asset.type);
      values.asset.type = normalizedHealthSafetyTypeValue;
      if(requiresLocation(normalizedHealthSafetyTypeValue) && hasManualCoordinates(valueLat, valueLng)){
        const manualPoint = getLatLng(valueLat,valueLng);
        if (manualPoint) {
          point = manualPoint;
        }
      }
    }else{
      if(currentTab == 1){
        if((!dataAsset.id || dataAsset.primary_object_id != selectedObject.id) && selectedObject){
           point = getRandomLatLng(selectedObject.area);
        }
      }else{
        if(hasManualCoordinates(valueLat, valueLng)){
          const manualPoint = getLatLng(valueLat,valueLng);
          if (manualPoint) {
            point = manualPoint;
          }
        }
      }
    }
 
    const permitsPayload = (values.asset.permits || []).map((permit) => {
      const payload = {
        crop_usage: permit.crop_usage,
        rate: permit.rate,
        rate_per: permit.rate_per || null,
        min_rate: permit.min_rate ?? null,
        min_rate_unit: permit.min_rate_unit || null,
        max_rate: permit.max_rate ?? null,
        max_rate_unit: permit.max_rate_unit || null,
        whp_harvest: permit.whp_harvest || null,
        whp_grazing: permit.whp_grazing || null,
        permit_code: permit.permit_code,
        expiry_date: permit.expiry_date ? dateHelper.dateForAPI(permit.expiry_date) : null,
        attachment_id: permit.attachment_id || null,
      };
      if (permit.id) {
        payload.id = permit.id;
      }
      return payload;
    }).filter((permit) => permit.crop_usage);

    const cropsPayload = (values.asset.crops || []).map((crop) => {
      const payload = {
        crop_name: crop.crop_name,
        rate: crop.rate,
        rate_per: crop.rate_per || null,
        min_rate: crop.min_rate ?? null,
        min_rate_unit: crop.min_rate_unit || null,
        max_rate: crop.max_rate ?? null,
        max_rate_unit: crop.max_rate_unit || null,
        whp_harvest: crop.whp_harvest || null,
        whp_grazing: crop.whp_grazing || null,
        allow_use: crop.allow_use !== undefined ? crop.allow_use : true,
      };
      if (crop.id) {
        payload.id = crop.id;
      }
      return payload;
    }).filter((crop) => crop.crop_name);

    delete values.asset.permits;
    delete values.asset.crops;

    // Transform external trainer sentinel values before building the payload.
    // Per customer feedback: each external slot accepts at most one entry; the
    // secondary slot's JSON column is a single-element array when present.
    if (values.asset.category === 'education') {
      const isPrimaryExt = values.asset.primary_trainer_id === 'external';
      const secIds = (values.asset.secondary_trainer_ids || []).filter(id => id !== 'external');
      const hasSecExt = (values.asset.secondary_trainer_ids || []).includes('external');
      values.asset.primary_trainer_id = isPrimaryExt ? null : values.asset.primary_trainer_id;
      values.asset.primary_external_trainer = isPrimaryExt ? {
        name: values.asset.primary_ext_name,
        email: values.asset.primary_ext_email,
        company: values.asset.primary_ext_company || null,
        phone: values.asset.primary_ext_phone,
      } : null;
      values.asset.secondary_trainer_ids = secIds;
      values.asset.secondary_external_trainers = hasSecExt ? [{
        name: values.asset.sec_ext_name,
        email: values.asset.sec_ext_email,
        company: values.asset.sec_ext_company || null,
        phone: values.asset.sec_ext_phone,
      }] : [];
      delete values.asset.primary_ext_name;
      delete values.asset.primary_ext_email;
      delete values.asset.primary_ext_company;
      delete values.asset.primary_ext_phone;
      delete values.asset.sec_ext_name;
      delete values.asset.sec_ext_email;
      delete values.asset.sec_ext_company;
      delete values.asset.sec_ext_phone;
    }

    const sprayData = values.spray && Object.keys(values.spray).length > 0 ? { spray: values.spray } : {};

    const data = {
      facility: {
        ...values.asset,
        date_of_purchase: values.asset.date_of_purchase ? dateHelper.dateForAPI(values.asset.date_of_purchase) : '',
        manufacture_date: values.asset.manufacture_date ? dateHelper.dateForAPI(values.asset.manufacture_date) : '',
        warranty_expiry: values.asset.warranty_expiry ? dateHelper.dateForAPI(values.asset.warranty_expiry) : '',
        last_checked_date: values.asset.last_checked_date ? dateHelper.dateForAPI(values.asset.last_checked_date) : '',
        creation_date: values.asset.creation_date ? dateHelper.dateForAPI(values.asset.creation_date) : '',
        expiry_date: values.asset.expiry_date ? dateHelper.dateForAPI(values.asset.expiry_date) : '',
        date_of_birth: values.asset.date_of_birth ? dateHelper.dateForAPI(values.asset.date_of_birth) : '',
        weather_date: values.asset.weather_date ? dateHelper.dateForAPI(values.asset.weather_date) : '',
        weather_time: values.asset.weather_time ? dateHelper.getTime(values.asset.weather_time) : '',
        chemical_last_used: values.asset.chemical_last_used ? dateHelper.dateForAPI(values.asset.chemical_last_used) : '',

        // Format active_date for education assets
        active_date: values.asset.active_date ? dateHelper.dateForAPI(values.asset.active_date) : '',
        sire: values.asset.sire ? 1 : 0,
        point,
        tags: values.asset.category === 'health_and_safety' && requiresTags(normalizedHealthSafetyTypeValue) ? tags : [],
        attachment_id : attachmentId,
        available_to_contractor: values.asset.available_to_contractor ? 1 : 0,
        ...sprayData,
        property_id: props.propertyId,
        displayed_name: color +  ' | ' + values.asset.tag_number,
        permits: permitsPayload,
        crops: cropsPayload,
        // Auto-populate created_by for education assets if not already set
        created_by: values.asset.category === 'education' && !values.asset.created_by && currentUser
          ? currentUser.name
          : values.asset.created_by,
      }
    }

    assetService.storeOrUpdate(data, dataAsset.id).then(res => {
      if(res.code === '0000'){
        
        props.onSaved(res.facility);
        setLoading(false);
        cancelModal();
        setAnimalSire(animalSire =>[...animalSire,values.asset.animal_sire_id]);
        form.resetFields();
        setTags([]);
      } else {
        setLoading(false);
      }
    });
  }

  const renderOptionsAssetCategory = () => {
    let options = [];
    _.forEach(assetCategories, (cat, index) => {
      options.push(
        <Option key={index} value={cat.value}>
          <div>{cat.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a category"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsInventoryType = () => {
    let options = [];
    _.forEach(inventoryTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a inventory type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsTankStorageTypes = () => {
    let options = [];
    _.forEach(tankStorageTypes, (storage, index) => {
      options.push(
        <Option key={index} value={storage.value}>
          <div>{storage.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a storage type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsAssetState = () => {
    let options = [];
    _.forEach(assetStates, (state, index) => {
      options.push(
        <Option key={index} value={state.value}>
          <ColorItemRow>
            <ColorItemPreview style={{backgroundColor: state.color}}></ColorItemPreview>
            <div>{state.label}</div>
          </ColorItemRow>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a state"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsContainerUnit = () => {
    let options = [];
    _.forEach(containerUnits, (unit, index) => {
      options.push(
        <Option key={index} value={unit.value}>
          <div>{unit.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a container unit"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsTreatmentRate = () => {
    let options = [];
    _.forEach(treatmentRates, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a rate"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }  

  const healthSafetyOptionGroups = React.useMemo(
    () => getHealthSafetyTypeOptionsByCategory(),
    []
  );

  const renderOptionsHealthSafetyTypes = () => (
    <Select
      placeholder="Select a Health Safety Types"
      allowClear
      size="large"
      showSearch
      optionFilterProp="label"
    >
      {healthSafetyOptionGroups.map((group) => (
        <OptGroup key={group.value} label={group.label}>
          {group.options.map((option) => (
            <Option key={option.value} value={option.value} label={option.label}>
              <div>{option.label}</div>
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );

  const renderOptionsFuelType = () => {
    let options = [];
    _.forEach(fuelTypes, (fuel, index) => {
      options.push(
        <Option key={index} value={fuel.value}>
          <div>{fuel.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a fuel type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsFuelContainerUnit = () => {
    let options = [];
    _.forEach(fuelContainerUnits, (fuel_unit, index) => {
      options.push(
        <Option key={index} value={fuel_unit.value}>
          <div>{fuel_unit.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a unit"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsStorageTypes = () => {
    let options = [];
    _.forEach(storageTypes, (storage, index) => {
      options.push(
        <Option key={index} value={storage.value}>
          <div>{storage.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a storage type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }
  const renderOptionsFeedUnits = () => {
    let options = [];
    _.forEach(feedUnits, (unit, index) => {
      options.push(
        <Option key={index} value={unit.value}>
          <div>{unit.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a feed unit"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsWaterStorageTypes = () => {
    let options = [];
    _.forEach(waterStorageTypes, (water_type, index) => {
      options.push(
        <Option key={index} value={water_type.value}>
          <div>{water_type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a water storage type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsAircraftType = () => {
    let options = [];
    _.forEach(aircraftTypes, (aircraft_type, index) => {
      options.push(
        <Option key={index} value={aircraft_type.value}>
          <div>{aircraft_type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a aircraft type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }
  const renderOptionsAircraftUnit = () => {
    let options = [];
    _.forEach(aircraftUnits, (aircraft_unit, index) => {
      options.push(
        <Option key={index} value={aircraft_unit.value}>
          <div>{aircraft_unit.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a aircraft unit"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select an object"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionAnimalType = () => {
    let options = [];
    _.forEach(animalTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          {type.label}
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select an animal type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsColor = () => {
    let options = [];
    _.forEach(objectColors, (color, index) => {
      options.push(
        <Option key={index} value={color.value}>
          <ColorItemRow>
            <ColorItemPreview style={{backgroundColor: color.color}}></ColorItemPreview>
            <div>{color.label}</div>
          </ColorItemRow>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a color"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionsWeatherTypes = () => {
    let options = [];
    _.forEach(weatherTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a weather type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }   
  const renderOptionsLevelTypes = () => {
    let options = [];
    _.forEach(levelTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a level"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderEducationTypes = () => {
    return (
      <Select placeholder="Select education type" allowClear size="large">
        {educationTypes.map((type, index) => (
          <Option key={index} value={type.value}>{type.label}</Option>
        ))}
      </Select>
    );
  }

  const renderOptionsShedTypes = () => {
    let options = [];
    _.forEach(shedTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsWaterTypes = () => {
    let options = [];
    _.forEach(waterTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a type"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsWeatherDuration = () => {
    let options = [];
    _.forEach(weatherDuration, (duration, index) => {
      options.push(
        <Option key={index} value={duration.value}>
          <div>{duration.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a duration"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  } 

  const renderOptionsSire = (animal_sire) => {
    let options = [];
    _.forEach(animal_sire, (sire, index) => {
      options.push(
        <Option key={index} value={sire.id}>
          <div>{sire.animal_name}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a sire"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  // Render primary objects (polygons) on the map
  const renderPrimaryObjects = () => {
    if (!primaryObjects || primaryObjects.length === 0) {
      return null;
    }

    const colorMap = {
      'blue': '#31a6c5',
      'green': '#52c41a',
      'red': '#f5222d',
      'yellow': '#faad14',
      'purple': '#722ed1',
      'orange': '#fa8c16',
    };

    return primaryObjects.map((object) => {
      const color = colorMap[object.color] || '#31a6c5';

      return (
        <Polygon
          key={object.id}
          positions={object.area}
          fillColor={color}
          color={color}
          fillOpacity={0.2}
          weight={2}
        >
          <Tooltip permanent={true} direction="center" className="primary-objects-tooltip">
            <div>
              <p style={{ margin: 0, fontWeight: 'bold' }}>{object.name}</p>
            </div>
          </Tooltip>
        </Polygon>
      );
    });
  };

  return(
    <>
    <AssetModalWrapper
      visible={modalVisibility && modalData.type === 'asset'}
      onCancel={cancelModal}
      maskClosable={false}
      title={dataAsset.id ? <IntlMessages id="propertyPage.modal.asset.editAsset" /> : <IntlMessages id="propertyPage.modal.asset.addAsset"/>} 
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
    {
        modalLoading ?
        <Loader /> : 
          <Form
            form={form}
            layout="vertical"
            scrollToFirstError
            fields={fields}
            id="#1"
          >
          <div className="form-body">
          
            <Form.Item
              name={['asset', 'available_to_contractor']}
              className="isoInputWrapper"
              label="Available to contractors"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
                                                    
            <Form.Item
              name={['asset', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                  whitespace: true,
                },
                {
                  max:255,
                  message: 'Title must be maximum 255 characters.'
                },
              ]}
            >
              <Input size="large" placeholder="Input asset title"/>
            </Form.Item>
            <Form.Item
              name={['asset', 'category']}
              className="isoInputWrapper"
              label="Category"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionsAssetCategory()}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset']);
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').category === "inventory"){
                      return (
                        <div>
                          <Form.Item
                            name={['asset', 'type']}
                            className="isoInputWrapper"
                            label="Inventory Type"
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                              },
                            ]}
                          >
                            {renderOptionsInventoryType()}
                          </Form.Item>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                              return (prevValues['asset'] && (prevValues['asset'].type !== currentValues['asset'].type));
                            }}
                          >
                            {({ getFieldValue }) => {
                                if(getFieldValue('asset')){
                                  if (getFieldValue('asset').type === "other"){
                                    return (
                                      <Form.Item
                                        name={['asset', 'other_inventory_type']}
                                        className="isoInputWrapper"
                                        label="Other Inventory Type"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'This field is required',
                                            whitespace: true
                                          },
                                          {
                                            max:255,
                                            message: 'Other Inventory Type must be maximum 255 characters.'
                                          },
                                        ]}
                                      >
                                        <Input size="large" placeholder="Input other inventory type"/>
                                      </Form.Item>
                                    );
                                  }
                                  else if(getFieldValue('asset').type === "animal_treatment" || getFieldValue('asset').type === "fertiliser" 
                                    || getFieldValue('asset').type === "vaccine"){
                                    return (
                                      <div>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 8}}>
                                            <Form.Item
                                              name={['asset', 'container_unit']}
                                              className="isoInputWrapper"
                                              label="Container Unit"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsContainerUnit()}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              noStyle
                                              shouldUpdate={(prev, curr) =>
                                                prev?.asset?.container_unit !== curr?.asset?.container_unit ||
                                                prev?.asset?.other_container_unit !== curr?.asset?.other_container_unit
                                              }
                                            >
                                              {({ getFieldValue }) => {
                                                const unit = getFieldValue(['asset', 'container_unit']);
                                                const other = getFieldValue(['asset', 'other_container_unit']);
                                                const suffix = getContainerUnitSuffix(unit, other || '');
                                                return (
                                                  <Form.Item
                                                    name={['asset', 'container_size']}
                                                    className="isoInputWrapper"
                                                    label="Container Size"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'This field is required',
                                                      },
                                                    ]}
                                                  >
                                                    <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} addonAfter={suffix}/>
                                                  </Form.Item>
                                                );
                                              }}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              name={['asset', 'containers']}
                                              className="isoInputWrapper"
                                              label="Containers"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 8}}>
                                            <Form.Item
                                              name={['asset', 'remaining']}
                                              className="isoInputWrapper"
                                              label="Remaining"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              name={['asset', 'withholding']}
                                              className="isoInputWrapper"
                                              label="Withholding"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              name={['asset', 'ESI']}
                                              className="isoInputWrapper"
                                              label="ESI"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'dosage']}
                                              className="isoInputWrapper"
                                              label="Dosage"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={0} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'rate']}
                                              className="isoInputWrapper"
                                              label="Rate"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsTreatmentRate()}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prevValues, currentValues) => {
                                            return (prevValues['asset'] && (prevValues['asset'].rate !== currentValues['asset'].rate));
                                          }}
                                        >
                                          {({ getFieldValue }) => {
                                              if(getFieldValue('asset')){
                                                if (getFieldValue('asset').rate === "other"){
                                                  return (
                                                    <Form.Item
                                                      name={['asset', 'other_rate']}
                                                      className="isoInputWrapper"
                                                      label="Other Rate"
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message: 'This field is required',
                                                          whitespace: true
                                                        },
                                                        {
                                                          max:255,
                                                          message: 'Other Rate must be maximum 255 characters.'
                                                        },
                                                      ]}
                                                    >
                                                      <Input size="large" placeholder="Input other rate"/>
                                                    </Form.Item>
                                                  );
                                                }
                                              }
                                            }
                                          }
                                        </Form.Item>
                                        <Form.Item
                                          name={['asset', 'expiry_date']}
                                          className="isoInputWrapper"
                                          label="Expiry Date"
                                          rules={[
                                            {
                                              required: true,
                                              message: 'This field is required',
                                            },
                                          ]}
                                        >
                                          <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                                        </Form.Item>
                                      </div>
                                    );
                                  }
                                  else if (getFieldValue('asset').type === "fuel" || getFieldValue('asset').type === "chemical"){
                                    return (
                                      <div>
                                      <Row>
                                        <Col xs={{span: 24}} md={{span: getFieldValue('asset').type === 'fuel' ? 11 : 8}}>
                                          {getFieldValue('asset').type === 'fuel' ? 
                                            <Form.Item
                                              name={['asset', 'fuel_type']}
                                              className="isoInputWrapper"
                                              label="Fuel Type"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsFuelType()}
                                            </Form.Item> : 
                                            <Form.Item
                                              name={['asset', 'chemical_batch_number']}
                                              className="isoInputWrapper"
                                              label="Batch Number"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <Input style={{ width: '100%' }} size="large" />
                                            </Form.Item>
                                          }
                                        </Col>
                                        <Col xs={{span: 24}} md={{span: getFieldValue('asset').type === 'fuel' ? 11 : 7, offset: getFieldValue('asset').type === 'fuel' ? 2 : 1}}>
                                          <Form.Item
                                            name={['asset', 'container_unit']}
                                            className="isoInputWrapper"
                                            label="Units of Measurement"
                                            rules={[
                                              {
                                                required: true,
                                                message: 'This field is required',
                                              },
                                            ]}
                                          >
                                            {renderOptionsFuelContainerUnit()}
                                          </Form.Item>
                                        </Col>
                                        {getFieldValue('asset').type === 'chemical' ? 
                                        <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                          <Form.Item
                                            name={['asset', 'containers']}
                                            className="isoInputWrapper"
                                            label="Containers"
                                            rules={[
                                              {
                                                required: false,
                                                message: 'This field is required',
                                              },
                                            ]}
                                          >
                                            <InputNumber style={{ width: '100%' }} size="large" min={0} max={1000} />
                                          </Form.Item>
                                        </Col> : ''}
                                      </Row>
                                      {getFieldValue("asset").type === "chemical" && (
                                        <Row>
                                          <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                            <Form.Item
                                              name={["asset", "formulation_type"]}
                                              className="isoInputWrapper"
                                              label="Formulation Type"
                                            >
                                              <Select size="large" placeholder="Select formulation type" allowClear>
                                                {FORMULATION_TYPES.map(ft => (
                                                  <Option key={ft.value} value={ft.value}>{ft.label}</Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      )}
                                      <Row>
                                        <Col xs={{span: 24}} md={{span: 11}}>
                                          <Form.Item
                                              noStyle
                                              shouldUpdate={(prevValues, currentValues) => {
                                                return (prevValues['asset'] && (prevValues['asset'].fuel_type !== currentValues['asset'].fuel_type));
                                              }}
                                            >
                                              {({ getFieldValue }) => {
                                                  if(getFieldValue('asset')){
                                                    if (getFieldValue('asset').fuel_type === "other"){
                                                      return (
                                                        <Form.Item
                                                          name={['asset', 'other_fuel_type']}
                                                          className="isoInputWrapper"
                                                          label="Other Fuel Type"
                                                          rules={[
                                                            {
                                                              required: true,
                                                              message: 'This field is required',
                                                              whitespace: true
                                                            },
                                                            {
                                                              max:255,
                                                              message: 'Other Fuel Type must be maximum 255 characters.'
                                                            },
                                                          ]}
                                                        >
                                                          <Input size="large" placeholder="Input other fuel type"/>
                                                        </Form.Item>
                                                      );
                                                    }
                                                  }
                                                }
                                              }
                                          </Form.Item>
                                        </Col>
                                        <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                          <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].container_unit !== currentValues['asset'].container_unit));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').container_unit === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_container_unit']}
                                                        className="isoInputWrapper"
                                                        label="Other Container Unit"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Container Unit Type must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other container unit"/>
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                      <Row>
                                          <Col xs={{span: 24}} md={{span: 8}}>
                                            <Form.Item
                                              noStyle
                                              shouldUpdate={(prev, curr) =>
                                                prev?.asset?.container_unit !== curr?.asset?.container_unit ||
                                                prev?.asset?.other_container_unit !== curr?.asset?.other_container_unit
                                              }
                                            >
                                              {({ getFieldValue }) => {
                                                const unit = getFieldValue(['asset', 'container_unit']);
                                                const other = getFieldValue(['asset', 'other_container_unit']);
                                                const suffix = getFuelContainerUnitSuffix(unit, other || '');
                                                return (
                                                  <Form.Item
                                                    name={['asset', 'container_size']}
                                                    className="isoInputWrapper"
                                                    label="Container Size"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'This field is required',
                                                      },
                                                    ]}
                                                  >
                                                    <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} addonAfter={suffix}/>
                                                  </Form.Item>
                                                );
                                              }}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              name={['asset', 'remaining']}
                                              className="isoInputWrapper"
                                              label="Remaining"
                                              rules={[
                                                {
                                                  required: getFieldValue('asset').type === 'fuel' ? true : false,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 7, offset: 1}}>
                                            <Form.Item
                                              name={['asset', 'expiry_date']}
                                              className="isoInputWrapper"
                                              label="Expiry Date"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        {getFieldValue('asset').type === 'chemical' ? 
                                        <div><Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'chemical_last_used']}
                                              className="isoInputWrapper"
                                              label="Last Used"
                                            >
                                              <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'rate']}
                                              className="isoInputWrapper"
                                              label="Usage Rate"
                                            >
                                              {renderOptionsTreatmentRate()}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prevValues, currentValues) => {
                                            return (prevValues['asset'] && (prevValues['asset'].rate !== currentValues['asset'].rate));
                                          }}
                                        >
                                          {({ getFieldValue }) => {
                                              if(getFieldValue('asset')){
                                                if (getFieldValue('asset').rate === "other"){
                                                  return (
                                                    <Form.Item
                                                      name={['asset', 'other_rate']}
                                                      className="isoInputWrapper"
                                                      label="Other Rate"
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message: 'This field is required',
                                                          whitespace: true
                                                        },
                                                        {
                                                          max:255,
                                                          message: 'Other Rate must be maximum 255 characters.'
                                                        },
                                                      ]}
                                                    >
                                                      <Input size="large" placeholder="Input other rate"/>
                                                    </Form.Item>
                                                  );
                                                }
                                              }
                                            }
                                          }
                                        </Form.Item></div> : ''}
                                      </div>
                                    );
                                  }
                                  else if (getFieldValue('asset').type === "stock_feed")
                                  {
                                    return (
                                      <div>
                                        <Form.Item
                                          name={['asset', 'feed_type']}
                                          className="isoInputWrapper"
                                          label="Feed Type"
                                          rules={[
                                            {
                                              required: true,
                                              message: 'This field is required',
                                              whitespace: true,
                                            },
                                            {
                                              max:255,
                                              message: 'Feed Type must be maximum 255 characters.'
                                            },
                                          ]}
                                        >
                                          <Input size="large" placeholder="Input feed type"/>
                                        </Form.Item>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'storage_type']}
                                              className="isoInputWrapper"
                                              label="Storage Type"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsStorageTypes()}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'storage_location']}
                                              className="isoInputWrapper"
                                              label="Storage Location"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionObject(props.primaryObjects)}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].storage_type !== currentValues['asset'].storage_type));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').storage_type === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_storage_type']}
                                                        className="isoInputWrapper"
                                                        label="Other Storage Type"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Storage Type must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other storage type"/>
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                          </Form.Item>
                                          <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'feed_unit']}
                                              className="isoInputWrapper"
                                              label="Feed Unit"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsFeedUnits()}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'volume']}
                                              className="isoInputWrapper"
                                              label="Volume"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].feed_unit !== currentValues['asset'].feed_unit));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').feed_unit === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_feed_unit']}
                                                        className="isoInputWrapper"
                                                        label="Other Feed Unit"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Feed Unit must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other feed unit"/>
                                                      </Form.Item>
                                                    );
                                                  }else if (getFieldValue('asset').feed_unit === "bale"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'bale_weight']}
                                                        className="isoInputWrapper"
                                                        label="Bale Weight"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                          },
                                                        ]}
                                                      >
                                                        <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                          </Form.Item>
                                          <Form.Item
                                            name={['asset', 'current_volume']}
                                            className="isoInputWrapper"
                                            label="Current Volume"
                                            rules={[
                                              {
                                                required: true,
                                                message: 'This field is required',
                                              },
                                            ]}
                                          >
                                            <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                          </Form.Item>
                                      </div>
                                    );
                                  }
                                  else if (getFieldValue('asset').type === "water")
                                  {
                                    return (
                                      <div>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'storage_type']}
                                              className="isoInputWrapper"
                                              label="Storage Type"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsWaterStorageTypes()}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'storage_location']}
                                              className="isoInputWrapper"
                                              label="Storage Location"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionObject(props.primaryObjects)}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].storage_type !== currentValues['asset'].storage_type));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').storage_type === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_storage_type']}
                                                        className="isoInputWrapper"
                                                        label="Other Storage Type"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Storage Type must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other storage type"/>
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                          </Form.Item>
                                          <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'volume']}
                                              className="isoInputWrapper"
                                              label="Volume"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                            name={['asset', 'current_volume']}
                                            className="isoInputWrapper"
                                            label="Current Volume"
                                            rules={[
                                              {
                                                required: true,
                                                message: 'This field is required',
                                              },
                                            ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      </div>
                                    );
                                  }
                                  else if(getFieldValue('asset').type === "aircraft")
                                  {
                                    return (
                                      <div>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'aircraft_type']}
                                              className="isoInputWrapper"
                                              label="Aircraft Type"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsAircraftType()}
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'storage_location']}
                                              className="isoInputWrapper"
                                              label="Storage Location"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionObject(props.primaryObjects)}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].aircraft_type !== currentValues['asset'].aircraft_type));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').aircraft_type === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_aircraft_type']}
                                                        className="isoInputWrapper"
                                                        label="Other Aircraft Type"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Aircraft Type must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other aircraft type"/>
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                        </Form.Item>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'aircraft_model']}
                                              className="isoInputWrapper"
                                              label="Aircraft Model"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'container_unit']}
                                              className="isoInputWrapper"
                                              label="Unit of measurement"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              {renderOptionsAircraftUnit()}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(prevValues, currentValues) => {
                                              return (prevValues['asset'] && (prevValues['asset'].container_unit !== currentValues['asset'].container_unit));
                                            }}
                                          >
                                            {({ getFieldValue }) => {
                                                if(getFieldValue('asset')){
                                                  if (getFieldValue('asset').container_unit === "other"){
                                                    return (
                                                      <Form.Item
                                                        name={['asset', 'other_container_unit']}
                                                        className="isoInputWrapper"
                                                        label="Other Unit Of Measurement"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: 'This field is required',
                                                            whitespace: true
                                                          },
                                                          {
                                                            max:255,
                                                            message: 'Other Unit Of Measurement must be maximum 255 characters.'
                                                          },
                                                        ]}
                                                      >
                                                        <Input size="large" placeholder="Input other unit of measurement"/>
                                                      </Form.Item>
                                                    );
                                                  }
                                                }
                                              }
                                            }
                                        </Form.Item>
                                        <Row>
                                          <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'current_fuel_level']}
                                              className="isoInputWrapper"
                                              label="Current Fuel Level"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'volume']}
                                              className="isoInputWrapper"
                                              label="Fuel Capacity"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]}
                                            >
                                              <InputNumber style={{ width: '100%' }} size="large" min={1} max={1000} />
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      </div>
                                    );
                                  }
                                }
                              }
                            }
                          </Form.Item>
                        </div>
                      );
                    }else if (getFieldValue('asset').category === "other"){
                      return (
                        <div>
                          <Form.Item
                            name={['asset', 'other_category']}
                            className="isoInputWrapper"
                            label="Other Category"
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                                whitespace: true
                              },
                              {
                                max:255,
                                message: 'Other Category must be maximum 255 characters.'
                              },
                            ]}
                          >
                            <Input size="large" placeholder="Input other category"/>
                          </Form.Item>
                        </div>
                      );
                    }else if (getFieldValue('asset').category === 'animal'){
                      return (
                        <div>
                          <Form.Item
                            name={['asset', 'animal_name']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="propertyPage.modal.asset.animalName" />}
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                                whitespace: true
                              },
                              {
                                max:255,
                                message: 'Name must be maximum 255 characters.'
                              },
                            ]}
                          >
                            <Input size="large" placeholder="Input animal name"/>
                          </Form.Item>
                          <Row>
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'animal_type']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.animalType" />}
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                {renderOptionAnimalType()}
                              </Form.Item>
                            </Col>
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => {
                                  return (prevValues['asset'] && (prevValues['asset'].animal_type !== currentValues['asset'].animal_type));
                                }}
                              >
                                {({ getFieldValue }) => {
                                    if(getFieldValue('asset')){
                                      if (getFieldValue('asset').animal_type === "other"){
                                        return (
                                          <Form.Item
                                            name={['asset', 'other_animal_type']}
                                            className="isoInputWrapper"
                                            label={<IntlMessages id="propertyPage.modal.asset.otherAnimalType" />}
                                            rules={[
                                              {
                                                required: true,
                                                message: 'This field is required',
                                                whitespace: true
                                              },
                                              {
                                                max:255,
                                                message: 'Other Animal Type must be maximum 255 characters.'
                                              },
                                            ]}
                                          >
                                            <Input size="large" placeholder="Input other animal type"/>
                                          </Form.Item>
                                        );
                                      }

                                      if (getFieldValue('asset').category === "animal"){
                                        return (
                                          <Form.Item
                                            name={['asset', 'animal_sire_id']}
                                            className="isoInputWrapper"
                                            label={<IntlMessages id="propertyPage.modal.asset.sire" />}
                                          >
                                            {renderOptionsSire(animalSire)}
                                          </Form.Item>
                                        );
                                      }
                                    }
                                  }
                                }
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'sire']}
                                className="isoInputWrapper"
                                valuePropName="checked"
                                label={<IntlMessages id="propertyPage.modal.asset.sire" />}
                              >
                                <Checkbox className="checkbox-contact"></Checkbox>
                              </Form.Item>
                            </Col>
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                name={['asset', 'date_of_birth']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.dateOfBirth" />}
                              >
                                <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'tag_number']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.tagNumber" />}
                              >
                                 <Input size="large" placeholder="Input tag number"/>
                              </Form.Item>
                            </Col>
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                name={['asset', 'tag_colour']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.tagColour" />}
                              >
                                {renderOptionsColor()}
                              </Form.Item>
                            </Col>
                          </Row>
                          <Form.Item
                            name={['asset', 'primary_object_id']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="propertyPage.modal.asset.paddock" />}
                            rules={[
                              {
                                required: getFieldValue('asset').category === 'animal' ? false : true,
                                message: 'This field is required',
                              },
                            ]}
                          >
                            {renderOptionObject(props.primaryObjects)}
                          </Form.Item>
                          <Form.Item
                            name={['asset', 'unique_features']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="propertyPage.modal.asset.uniqueFeature" />}
                          >
                            <Input.TextArea />
                          </Form.Item>
                        </div>
                      )
                    }else if (getFieldValue('asset').category === 'weather'){
                      return (
                        <div>
                          <Row>
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'weather_type']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.weatherType" />}
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                {renderOptionsWeatherTypes()}
                              </Form.Item>
                            </Col>
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                <Form.Item
                                  name={['asset', 'primary_object_id']}
                                  className="isoInputWrapper"
                                  label={<IntlMessages id="propertyPage.modal.asset.paddock" />}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'This field is required',
                                    },
                                  ]}
                                >
                                  {renderOptionObject(props.primaryObjects)}
                          </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'weather_date']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.date" />}
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                              </Form.Item>
                            </Col>
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                name={['asset', 'weather_time']}
                                className="isoInputWrapper"
                                label={<IntlMessages id="propertyPage.modal.asset.time" />}
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                <TimePicker size="large" style={{width: '100%'}} />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Form.Item
                            name={['asset', 'weather_comment']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="propertyPage.modal.asset.weatherComment" />}
                          >
                            <Input.TextArea />
                          </Form.Item>
                        </div>
                      )
                    }
                    else if (getFieldValue('asset').category === "storage"){
                    return (
                      <div>
                        <Form.Item
                          name={['asset', 'type']}
                          className="isoInputWrapper"
                          label="Storage Type"
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                          {renderOptionsTankStorageTypes()}
                        </Form.Item>

                        <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '4px', marginBottom: '16px' }}>
                          <h4 style={{ marginTop: 0 }}>Tank Capacity Configuration</h4>
                          
                          <Form.Item
                            name={['asset', 'measurement_direction']}
                            label="Sensor Measurement Direction"
                            initialValue="top_to_bottom"
                            rules={[{ required: true, message: 'Please select measurement direction' }]}
                          >
                            <Radio.Group>
                              <Radio value="bottom_to_top">
                                <span>Bottom → Top</span>
                                <div style={{ fontSize: '12px', color: '#666', marginLeft: '24px' }}>
                                  (Sensor measures upwards from bottom - height increases as tank fills)
                                </div>
                              </Radio>
                              <Radio value="top_to_bottom" style={{ marginTop: '8px' }}>
                                <span>Top → Bottom</span>
                                <div style={{ fontSize: '12px', color: '#666', marginLeft: '24px' }}>
                                  (Sensor measures downwards from top - height decreases as tank fills)
                                </div>
                              </Radio>
                            </Radio.Group>
                          </Form.Item>

                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                              return prevValues?.asset?.measurement_direction !== currentValues?.asset?.measurement_direction;
                            }}
                          >
                            {({ getFieldValue }) => {
                              const direction = getFieldValue(['asset', 'measurement_direction']) || 'top_to_bottom';
                              const isBottomToTop = direction === 'bottom_to_top';
                              
                              return (
                                <>
                                  <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px', marginTop: '16px' }}>
                                    {isBottomToTop 
                                      ? 'Configure sensor measurements from bottom of tank. Height increases as tank fills.'
                                      : 'Configure sensor measurements from top of tank. Height decreases as tank fills.'
                                    }
                                  </p>

                                  <Row gutter={16}>
                                    <Col xs={24} md={11}>
                                      <div style={{ marginBottom: '16px' }}>
                                        <h5 style={{ marginBottom: '8px' }}>At 100% (Full Tank)</h5>
                                        <Form.Item
                                          name={['asset', 'height_at_100']}
                                          label="Height (mm)"
                                          rules={[
                                            { required: true, message: 'Required' },
                                            { type: 'number', min: 0, message: 'Must be 0 or greater' },
                                          ]}
                                        >
                                          <InputNumber
                                            style={{ width: '100%' }}
                                            size="large"
                                            placeholder={isBottomToTop ? "e.g., 2500mm" : "e.g., 10mm"}
                                            min={0}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          name={['asset', 'litres_at_100']}
                                          label="Volume (Litres)"
                                          rules={[
                                            { required: true, message: 'Required' },
                                            { type: 'number', min: 0, message: 'Must be 0 or greater' },
                                            ({ getFieldValue }) => ({
                                              validator(_, value) {
                                                const litresAt0 = getFieldValue(['asset', 'litres_at_0']);
                                                if (!value || !litresAt0 || value > litresAt0) {
                                                  return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Volume at 100% must be greater than volume at 0%'));
                                              },
                                            }),
                                          ]}
                                        >
                                          <InputNumber
                                            style={{ width: '100%' }}
                                            size="large"
                                            placeholder="e.g., 10000L"
                                            min={0}
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>

                                    <Col xs={0} md={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch' }}>
                                      <div style={{ 
                                        width: '1px', 
                                        backgroundColor: '#d9d9d9',
                                        margin: '0 auto'
                                      }} />
                                    </Col>

                                    <Col xs={24} md={11}>
                                      <div style={{ marginBottom: '16px' }}>
                                        <h5 style={{ marginBottom: '8px' }}>At 0% (Empty Tank)</h5>
                                        <Form.Item
                                          name={['asset', 'height_at_0']}
                                          label="Height (mm)"
                                          rules={[
                                            { required: true, message: 'Required' },
                                            { type: 'number', min: 0, message: 'Must be 0 or greater' },
                                          ]}
                                        >
                                          <InputNumber
                                            style={{ width: '100%' }}
                                            size="large"
                                            placeholder={isBottomToTop ? "e.g., 50mm" : "e.g., 2500mm"}
                                            min={0}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          name={['asset', 'litres_at_0']}
                                          label="Volume (Litres)"
                                          rules={[
                                            { required: true, message: 'Required' },
                                            { type: 'number', min: 0, message: 'Must be 0 or greater' },
                                            ({ getFieldValue }) => ({
                                              validator(_, value) {
                                                const litresAt100 = getFieldValue(['asset', 'litres_at_100']);
                                                if (!value || !litresAt100 || value < litresAt100) {
                                                  return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Volume at 0% must be less than volume at 100%'));
                                              },
                                            }),
                                          ]}
                                          dependencies={[['asset', 'litres_at_100']]}
                                        >
                                          <InputNumber
                                            style={{ width: '100%' }}
                                            size="large"
                                            placeholder="e.g., 0L"
                                            min={0}
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              );
                            }}
                          </Form.Item>
                        </div>
                      </div>
                    )
                  }
                  }
                }
              }
            </Form.Item>
 
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset']);
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').category !== "animal" && getFieldValue('asset').category !== "weather"){
                      return (
                        <div>
                          <Row>
                            {getFieldValue('asset').category !== "health_and_safety" && 
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'state']}
                                className="isoInputWrapper"
                                label={getFieldValue('asset').category === 'water' ? "Level":"State"}
                                rules={getFieldValue('asset')?.type !== 'dam' ? [
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ] : []}
                              >
                                {getFieldValue('asset').category !== 'water' ? renderOptionsAssetState() : renderOptionsLevelTypes()}
                              </Form.Item>
                            </Col>
                            }
                            {getFieldValue('asset').category === 'water' && 
                              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                                <Form.Item
                                name={['asset', 'type']}
                                className="isoInputWrapper"
                                label="Type"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                {renderOptionsWaterTypes()}
                              </Form.Item>
                              </Col>
                            }
                            {getFieldValue('asset').category !== "health_and_safety" && getFieldValue('asset').category !== 'water' && getFieldValue('asset').category !== 'education' &&
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                name={['asset', 'date_of_purchase']}
                                className="isoInputWrapper"
                                label="Date Of Purchase"
                                rules={[
                                  {
                                    required: getFieldValue('asset').type === 'chemical' ? false : true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                              </Form.Item>
                            </Col>
                            }
                          </Row>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                              return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
                            }}
                          >
                            {({ getFieldValue }) => {
                                if(getFieldValue('asset')){
                                  if (getFieldValue('asset').state === "other"){
                                    return (
                                      <Form.Item
                                        name={['asset', 'other_state']}
                                        className="isoInputWrapper"
                                        label="Other State"
                                        rules={[
                                          {
                                            required: true,
                                            message: 'This field is required',
                                          },
                                        ]}
                                      >
                                        <Input size="large" placeholder="Input other state"/>
                                      </Form.Item>
                                    );
                                  }
                                }
                              }
                            }
                          </Form.Item>
                          <Row>
                            {getFieldValue('asset').category !== "health_and_safety" && getFieldValue('asset').category !== 'water' && getFieldValue('asset').category !== 'education' &&
                            <Col xs={{span: 24}} md={{span: 11}}>
                              <Form.Item
                                name={['asset', 'manufacture_date']}
                                className="isoInputWrapper"
                                label="Manufacture Date"
                                rules={[
                                  {
                                    required: getFieldValue('asset').type === 'chemical' ? false : true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                              </Form.Item>
                            </Col>
                            }
                            {getFieldValue('asset').category !== "water" && getFieldValue('asset').category !== "shed" && getFieldValue('asset').category !== "health_and_safety" && getFieldValue('asset').category !== 'education' &&
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                shouldUpdate={(prevValues, currentValues) => {
                                  return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
                                }}
                                name={['asset', 'primary_object_id']}
                                className="isoInputWrapper"
                                label="Location"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is required',
                                  },
                                ]}
                              >
                                {renderOptionObject(props.primaryObjects)}
                              </Form.Item>
                            </Col>
                          }
                          {getFieldValue('asset').category === "shed" && 
                            <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                              <Form.Item
                                  name={['asset', 'type']}
                                  className="isoInputWrapper"
                                  label="Shed Type"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'This field is required',
                                    },
                                  ]}
                                >
                                  {renderOptionsShedTypes() } 
                                </Form.Item>
                            </Col>
                          }
                          </Row>
                          {getFieldValue("asset").category === "machinery" && (
                            <div>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "manufacturer"]}
                                    className="isoInputWrapper"
                                    label="Manufacturer"
                                  >
                                    <Input size="large" placeholder="e.g. John Deere" />
                                  </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                  <Form.Item
                                    name={["asset", "make"]}
                                    className="isoInputWrapper"
                                    label="Make"
                                  >
                                    <Input size="large" placeholder="Make" />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "model"]}
                                    className="isoInputWrapper"
                                    label="Model"
                                  >
                                    <Input size="large" placeholder="Model" />
                                  </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                  <Form.Item
                                    name={["asset", "serial_vin"]}
                                    className="isoInputWrapper"
                                    label="Serial / VIN"
                                  >
                                    <Input size="large" placeholder="Serial number or VIN" />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "registration"]}
                                    className="isoInputWrapper"
                                    label="Registration"
                                  >
                                    <Input size="large" placeholder="Registration" />
                                  </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                  <Form.Item
                                    name={["asset", "warranty_expiry"]}
                                    className="isoInputWrapper"
                                    label="Warranty Expiry"
                                  >
                                    <DatePicker
                                      size="large"
                                      style={{ width: "100%" }}
                                      format={dateFormat}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "service_interval"]}
                                    className="isoInputWrapper"
                                    label="Service Interval"
                                  >
                                    <InputNumber
                                      min={0}
                                      size="large"
                                      style={{ width: "100%" }}
                                      placeholder="e.g. 250"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                  <Form.Item
                                    name={["asset", "service_interval_unit"]}
                                    className="isoInputWrapper"
                                    label="Interval Unit"
                                  >
                                    <Select size="large" allowClear placeholder="Select unit">
                                      <Option value="hours">Hours</Option>
                                      <Option value="km">Kilometres</Option>
                                      <Option value="miles">Miles</Option>
                                      <Option value="days">Days</Option>
                                      <Option value="months">Months</Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["asset", "current_reading"]}
                                    className="isoInputWrapper"
                                    label="Current Reading"
                                    tooltip="Latest hours/odometer reading. Service logs advance this automatically."
                                  >
                                    <InputNumber
                                      min={0}
                                      size="large"
                                      style={{ width: "100%" }}
                                      placeholder="e.g. 1240"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                                  <Form.Item
                                    name={["asset", "reading_unit"]}
                                    className="isoInputWrapper"
                                    label="Reading Unit"
                                  >
                                    <Select size="large" allowClear placeholder="Select unit">
                                      <Option value="hours">Hours</Option>
                                      <Option value="km">Kilometres</Option>
                                      <Option value="miles">Miles</Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          )}
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                               return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
                            }}
                          >
                            {({ getFieldValue }) => {
                                if(getFieldValue('asset')){
                                  if (getFieldValue('asset').category === "health_and_safety"){
                                    return (
                                      <div>
                                          <Row>
                                            <Col xs={{span: 24}} md={{span: 24}}>
                                              <Form.Item
                                                name={['asset', 'type']}
                                                className="isoInputWrapper"
                                                label={<IntlMessages id="propertyPage.modal.asset.healthSafetyTypes" />}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: 'This field is required',
                                                  },
                                                ]}
                                              >
                                                {renderOptionsHealthSafetyTypes()}
                                              </Form.Item>
                                            </Col>
                                            
                                          </Row>


                                          <Form.Item
                                              noStyle
                                              shouldUpdate={(prevValues, currentValues) => {
                                                 return (prevValues['asset'] && (prevValues['asset'].type !== currentValues['asset'].type));
                                              }}
                                            >
                                            {({ getFieldValue }) => {
                                              if(getFieldValue('asset') && getFieldValue('asset').type){
                                                  const assetHealthType = normalizeHealthSafetyType(getFieldValue('asset').type);
                                                  return (
                                                    <div>
                                                      <Row>
                                                      {requiresLastCheckedDate(assetHealthType) &&
                                                      <Col xs={{span: 24}} md={{span: 11}}>
                                                        <Form.Item
                                                          name={['asset', 'last_checked_date']}
                                                          className="isoInputWrapper"
                                                          label="Last Checked Date"
                                                          rules={[
                                                            {
                                                              required: true,
                                                              message: 'This field is required',
                                                            },
                                                          ]}
                                                        >
                                                          <DatePicker size="large" style={{width: '100%'}} format={dateFormat} />
                                                        </Form.Item>
                                                      </Col>
                                                      }
                                                      { requiresCreationDate(assetHealthType) &&
                                                        <Col xs={{span: 24}} md={{span: 11,offset:2}}>
                                                          <Form.Item
                                                            name={['asset', 'creation_date']}
                                                            className="isoInputWrapper"
                                                            label="Creation Date"
                                                            rules={[
                                                              {
                                                                required: true,
                                                                message: 'This field is required',
                                                              },
                                                            ]}
                                                            >
                                                              <DatePicker size="large" style={{width: '100%'}} format={dateFormat} />
                                                            </Form.Item>
                                                          </Col> 
                                                          } 
                                                        </Row>
                                                        <Row>
                                                         <Col xs={{span: 24}} md={{span: 11}}>
                                                          <Form.Item
                                                            name={['asset', 'expiry_date']}
                                                            className="isoInputWrapper"
                                                            label="Expiry Date"
                                                            rules={[
                                                              {
                                                                required: true,
                                                                message: 'This field is required',
                                                              },
                                                            ]}
                                                          >
                                                            <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                                                          </Form.Item>
                                                          </Col>
                                                          {
                                                            requiresManufactureDate(assetHealthType) &&
                                                            <Col xs={{span: 24}} md={{span: 11,offset:2}}>
                                                              <Form.Item
                                                                name={['asset', 'manufacture_date']}
                                                                className="isoInputWrapper"
                                                                label="Manufacture Date"
                                                                rules={[
                                                                  {
                                                                    required: true,
                                                                    message: 'This field is required',
                                                                  },
                                                                ]}
                                                              >
                                                                <DatePicker size="large" style={{width: '100%'}} format={dateFormat}/>
                                                              </Form.Item>
                                                            </Col>
                                                            }
                                                            {
                                                              requiresTags(assetHealthType) &&
                                                                <Col xs={{span: 24}} md={{span: 11,offset:2}}>
                                                                  <Form.Item
                                                                    className="isoInputWrapper"
                                                                    label="Tags"
                                                                  >
                                                                    <TagsInput name={['asset', 'tags']} value={tags} onChange={handleChangeTag} addOnBlur="true"/>
                                                                  </Form.Item>
                                                                </Col>
                                                            }
                                                        </Row>  
                                                        
                                                        {
                                                          requiresLocation(assetHealthType) &&
                                                        <Row style={{marginBottom:'10px',marginTop:'5px'}}>
                                                          <Col xs={{span: 24}} md={{span: 24}} style={{marginBottom:'10px'}}>
                                                            <Map ref={mapRef} center={position[0] !== null ? position : false} doubleClickZoom={false} onclick={handleClickMap} zoom={16} zoomControl={true} style={{width:'100%', height:'300px'}}>
                                                            {propertyHelper.checkIsShowSatMap(property, activePropertySubscription) ?
                                                              <ReactLeafletGoogleLayer type={'hybrid'} useGoogMapsLoader={false}/> :
                                                                <TileLayer
                                                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                                />
                                                            }
                                                              <FeatureGroup>
                                                                {renderPrimaryObjects()}
                                                              </FeatureGroup>
                                                              {valueLat  && <Marker position={[valueLat,valueLng]} draggable={true}>
                                                                  <Popup position={[valueLat,valueLng]}>
                                                                  </Popup>
                                                              </Marker>}
                                                            </Map>
                                                          </Col>
                                                        
                                                          <Col xs={{span: 24}} md={{span: 11}}>  
                                                            <Form.Item
                                                              className="isoInputWrapper"
                                                              name='latitude'
                                                              label="Latitude"
                                                              value={valueLat}
                                                              rules={requiresLocation(assetHealthType) ? [
                                                                {
                                                                  required: true,
                                                                  message: 'This field is required',
                                                                },
                                                              ] : []}
                                                            >                          
                                                            <Input value={valueLat}/>
                                                            </Form.Item>
                                                          </Col>
                                                          <Col xs={{span: 24}} md={{span: 11, offset: 2}} >
                                                           <Form.Item
                                                              className="isoInputWrapper"
                                                              name='longitude'
                                                              label="Longitude"
                                                              value={valueLng}
                                                              rules={requiresLocation(assetHealthType) ? [
                                                                  {
                                                                    required: true,
                                                                    message: 'This field is required',
                                                                  },
                                                                ] : []}
                                                            >
                                                            <Input value={valueLng}/>
                                                            </Form.Item>
                                                          </Col> 
                                                        </Row>
                                                        }
                                                        <Row>
                                                        <Col xs={{span: 24}} md={{span: 11}}>
                                                             <Form.Item
                                                                name={['asset', 'created_by']}
                                                                className="isoInputWrapper"
                                                                label="Created By"
                                                                rules={[
                                                                  {
                                                                    required: true,
                                                                    message: 'This field is required',
                                                                  },
                                                                ]}
                                                              >
                                                                <Input size="large" placeholder="Created By"/>
                                                              </Form.Item>
                                                          </Col>
                                                      </Row>
                                                    
                                                      
                                                    </div>

                                                  )
                                               
                                            } 
                                          }
                                          }
                                          </Form.Item>

                                    </div>
                                  )
                                }
                               }
                              } 
                            }
                          </Form.Item>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                                return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
                            }}
                          >
                          {({ getFieldValue }) => {
                              if(getFieldValue('asset')){
                                if (getFieldValue('asset').category === "water"){
                                  return (
                                    <div>
                                      <Row>
                                        <Col xs={{span: 24}} md={{span: 11}}>
                                            <Form.Item
                                              name={['asset', 'creation_date']}
                                              className="isoInputWrapper"
                                              label="Creation Date"
                                              rules={getFieldValue('asset').type !== "dam" ? [
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]: []}
                                            >
                                              <DatePicker size="large" style={{width: '100%'}} format={dateFormat} defaultValue={moment()}/>
                                            </Form.Item>
                                          </Col>        
                                          <Col xs={{span: 24}} md={{span: 11,offset: 2}}>
                                            <Form.Item
                                              name={['asset', 'last_checked_date']}
                                              className="isoInputWrapper"
                                              label="Last Checked Date"
                                              rules={getFieldValue('asset').type !== "dam" ? [
                                                {
                                                  required: true,
                                                  message: 'This field is required',
                                                },
                                              ]: []}
                                            >
                                              <DatePicker size="large" style={{width: '100%'}} format={dateFormat} defaultValue={moment()}/>
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                        <Row>
                                              <Col>
                                                <Form.Item
                                                    name={['asset', 'quantity']}
                                                    className="isoInputWrapper"
                                                    label="Quantity"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'This field is required',
                                                      },
                                                    ]}
                                                  >
                                                    <InputNumber size="large" min={1}/>
                                                  </Form.Item>
                                              </Col>
                                        </Row>
                                        <Tabs defaultActiveKey="1" onChange={onChange}>
                                           
                                            <TabPane tab="Area" key="1">
                                              { currentTab == 1 && <Col xs={{span: 24}} md={{span: 11}}>
                                                <Form.Item
                                                 
                                                  name={['asset', 'primary_object_id']}
                                                  className="isoInputWrapper"
                                                  label="Location"
                                                  
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'This field is required',
                                                    },
                                                  ]}
                                                >
                                                  {renderOptionObject(props.primaryObjects)}
                                                </Form.Item>
                                              </Col>}
                                            </TabPane>

                                            <TabPane tab="Location" key="2" disabled={getFieldValue('asset').quantity > 1}>
                                              
                                              <Map ref={mapRef} center={position[0] !== null ? position : false} doubleClickZoom={false} onclick={handleClickMap} zoom={16} zoomControl={true} style={{width:'100%', height:'300px'}}>
                                                 {propertyHelper.checkIsShowSatMap(property, activePropertySubscription) ?
                                                    <ReactLeafletGoogleLayer type={'hybrid'} useGoogMapsLoader={false}/> :
                                                      <TileLayer
                                                      attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                      />
                                                  }
                                                  <FeatureGroup>
                                                    {renderPrimaryObjects()}
                                                  </FeatureGroup>
                                                  {valueLat  && <Marker position={[valueLat,valueLng]} draggable={true}>
                                                      <Popup position={[valueLat,valueLng]}>
                                                      </Popup>
                                                  </Marker>}
                                              </Map>
                                              <Row style={{marginTop:"10px", marginBottom:"5px"}}>
                                                  <Col xs={{span: 24}} md={{span: 11}} >
                                                      <Input value={valueLat}/>
                                                  </Col>
                                                  <Col xs={{span: 24}} md={{span: 11, offset: 2}} >
                                                      <Input value={valueLng}/>
                                                  </Col>
                                              </Row>
                                            </TabPane>
                                           
                                       </Tabs>
                                    </div>
                                  )
                                }
                                
                              }
                            }
                          }
                          {getFieldValue('asset').type === "chemical" &&
                                  
                                  <Row>
                                    <Col xs={{span: 24}} md={{span: 24}}>
                                      <Tabs defaultActiveKey="1" onChange={onChange}>
                                        <TabPane tab="Permit" key="permit">
                                          {renderPermitTab()}
                                        </TabPane>
                                        <TabPane tab="Crop" key="crop">
                                          {renderCropTab()}
                                        </TabPane>
                                      </Tabs>
                                    </Col>
                                  </Row>

                                  } 
                          </Form.Item>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => {
                                return (prevValues['asset'] && (prevValues['asset'].state !== currentValues['asset'].state));
                            }}
                          >
                          {({ getFieldValue }) => {
                              if(getFieldValue('asset')){
                                if (getFieldValue('asset').category === "shed"){
                                  return (
                                    <div>
                                        <Tabs defaultActiveKey="1" onChange={onChange}>
                                            <TabPane tab="Area" key="1">
                                              { currentTab == 1 && <Col xs={{span: 24}} md={{span: 11}}>
                                                <Form.Item
                                                 
                                                  name={['asset', 'primary_object_id']}
                                                  className="isoInputWrapper"
                                                  label="Location"
                                                  
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'This field is required',
                                                    },
                                                  ]}
                                                >
                                                  {renderOptionObject(props.primaryObjects)}
                                                </Form.Item>
                                              </Col>}
                                            </TabPane>

                                            <TabPane tab="Location" key="2">
                                              
                                              <Map ref={mapRef} center={position[0] !== null ? position : false} doubleClickZoom={false} onclick={handleClickMap} zoom={16} zoomControl={true} style={{width:'100%', height:'300px'}}>
                                              {propertyHelper.checkIsShowSatMap(property, activePropertySubscription) ?
                                                  <ReactLeafletGoogleLayer type={'hybrid'} useGoogMapsLoader={false}/> :
                                                    <TileLayer
                                                      attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    />
                                              }
                                                  <FeatureGroup>
                                                    {renderPrimaryObjects()}
                                                  </FeatureGroup>
                                                  {valueLat  && <Marker position={[valueLat,valueLng]} draggable={true}>
                                                      <Popup position={[valueLat,valueLng]}>
                                                      </Popup>
                                                  </Marker>}
                                              </Map>
                                              <Row style={{marginTop:"10px", marginBottom:"5px"}}>
                                                  <Col xs={{span: 24}} md={{span: 11}} >
                                                      <Input value={valueLat}/>
                                                  </Col>
                                                  <Col xs={{span: 24}} md={{span: 11, offset: 2}} >
                                                      <Input value={valueLng}/>
                                                  </Col>
                                              </Row>
                                            </TabPane>
                                       </Tabs>
                                    </div>
                                  )

                                }
                              }
                            }
                          }
                          </Form.Item>
                        </div>
                      )
                    }
                  }
                }
              }
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset']);
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').category === "spray"){
                      return (
                        <SprayForm form={form} />
                      )
                    }
                  }
                }
              }
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset']);
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    if (getFieldValue('asset').category === 'education') {
                      return (
                        <div>
                          <Form.Item
                            name={['asset', 'type']}
                            label="Education Type"
                            rules={[{ required: true, message: 'Education type is required' }]}
                          >
                            {renderEducationTypes()}
                          </Form.Item>

                          <Form.Item
                            name={['asset', 'primary_trainer_id']}
                            label="Primary Trainer"
                            className="isoInputWrapper"
                            rules={[{ required: true, message: 'Primary trainer is required' }]}
                          >
                            <Select
                              placeholder="Select primary trainer"
                              showSearch
                              allowClear
                              size="large"
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={(val) => setPrimaryTrainerIsExternal(val === 'external')}
                            >
                              <Option key="external" value="external" style={{ fontStyle: 'italic' }}>External Trainer</Option>
                              {users.map((user) => (
                                <Option key={user.id} value={user.id}>
                                  {user.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          {primaryTrainerIsExternal && (
                            <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: 4, padding: '12px 16px', marginBottom: 16 }}>
                              <Row gutter={12}>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'primary_ext_name']} label="Full Name" rules={[{ required: true, whitespace: true, message: 'Full name is required' }]}>
                                    <Input size="large" placeholder="Trainer full name" />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'primary_ext_email']} label="Email" rules={[{ required: true, whitespace: true, type: 'email', message: 'Valid email is required' }]}>
                                    <Input size="large" placeholder="trainer@example.com" />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={12}>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'primary_ext_phone']} label="Phone Number" rules={[{ required: true, whitespace: true, message: 'Phone number is required' }]}>
                                    <Input size="large" placeholder="+61 400 000 000" />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'primary_ext_company']} label="Company Name">
                                    <Input size="large" placeholder="Company (optional)" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          )}

                          <Form.Item
                            name={['asset', 'secondary_trainer_ids']}
                            label="Secondary Trainers"
                            className="isoInputWrapper"
                          >
                            <Select
                              mode="multiple"
                              placeholder="Select secondary trainers"
                              showSearch
                              allowClear
                              size="large"
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={(vals) => setSecondaryTrainerHasExternal(vals.includes('external'))}
                            >
                              <Option key="external" value="external" style={{ fontStyle: 'italic' }}>External Trainer</Option>
                              {users.map((user) => (
                                <Option key={user.id} value={user.id}>
                                  {user.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          {secondaryTrainerHasExternal && (
                            <div style={{ background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: 4, padding: '12px 16px', marginBottom: 16 }}>
                              <Row gutter={12}>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'sec_ext_name']} label="Full Name" rules={[{ required: true, whitespace: true, message: 'Full name is required' }]}>
                                    <Input size="large" placeholder="Trainer full name" />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'sec_ext_email']} label="Email" rules={[{ required: true, whitespace: true, type: 'email', message: 'Valid email is required' }]}>
                                    <Input size="large" placeholder="trainer@example.com" />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={12}>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'sec_ext_phone']} label="Phone Number" rules={[{ required: true, whitespace: true, message: 'Phone number is required' }]}>
                                    <Input size="large" placeholder="+61 400 000 000" />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item name={['asset', 'sec_ext_company']} label="Company Name">
                                    <Input size="large" placeholder="Company (optional)" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          )}

                          <Row gutter={16}>
                            <Col span={12}>
                              <Form.Item
                                name={['asset', 'active_date']}
                                label="Active Date"
                                className="isoInputWrapper"
                              >
                                <DatePicker
                                  format={dateFormat}
                                  style={{ width: '100%' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                name={['asset', 'validity_months']}
                                label="Validity (Months)"
                                className="isoInputWrapper"
                                initialValue={12}
                              >
                                <InputNumber min={1} style={{ width: '100%' }} />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Form.Item
                            name={['asset', 'expiry_date']}
                            label="Expiry Date"
                            className="isoInputWrapper"
                          >
                            <DatePicker
                              format={dateFormat}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>

                        </div>
                      );
                    }
                  }
                }
              }
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return (prevValues['asset']);
              }}
            >
              {({ getFieldValue }) => {
                  if(getFieldValue('asset')){
                    const category = getFieldValue('asset').category;
                    return (
                      <>
                        <Form.Item
                          name={['asset', 'attachment']}
                          className="isoInputWrapper"
                          label={<IntlMessages id="propertyPage.modal.asset.attachment" />}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            onClick={() => setFileBrowserVisible(true)}
                          >
                            <span style={{ marginLeft: 8 }}><IntlMessages id="fileBrowser.selectFiles" /></span>
                          </Button>
                          <SelectedFilesDisplay
                            files={selectedAttachments}
                            onRemove={handleRemoveAttachment}
                            onExpiryDateChange={(id, date) => handleExpiryDateChange(id, date ? dateHelper.dateForAPI(date) : null)}
                            onUserChange={handleUserChange}
                            users={users}
                            dateFormat={dateFormat}
                          />
                        </Form.Item>
                        {category !== "weather" && (
                          <Form.Item
                            name={['asset', 'description']}
                            className="isoInputWrapper"
                            label="Description"
                          >
                            <Input.TextArea />
                          </Form.Item>
                        )}
                      </>
                    );
                  }
                }
              }
            </Form.Item>
            
          </div>  
      </Form>
      }     
    </AssetModalWrapper>
    <FileBrowser
      visible={fileBrowserVisible}
      onCancel={() => setFileBrowserVisible(false)}
      onSelect={handleFileBrowserSelect}
      multiple={true}
      initialSelection={selectedAttachments}
      corporateGroupId={corporateGroupId}
      propertyId={activePropertyId}
    />
    </>
  )
}

export default AssetModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div{
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;
